import React from 'react';
import { Bar as Chart } from 'react-chartjs-2';
import {
	BarElement,
	CategoryScale,
	Chart as ChartJS,
	ArcElement,
	Tooltip,
	Legend,
	LinearScale
} from 'chart.js';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';

ChartJS.register(
	ArcElement,
	BarElement,
	CategoryScale,
	Tooltip,
	LinearScale,
	Legend
);

const StackedBar = ( {
	data = {},
	description,
	label
} ) => {
	return (
		<>
			<Header textAlign="center">
				{ label }
			</Header>
			<div
				style={ {
					height: '250px',
					width: '300px'
				} }
			>
				<Chart
					data={ data }
					options={ {
						aspectRatio: 1,
						maintainAspectRatio: false,
						plugins: { legend: { display: false } },
						responsive: true,
						scales: {
							x: {
								display: false,
								stacked: true
							},
							y: { stacked: true }
						}
					} }
				/>
			</div>
			<Header
				sub
				textAlign="center"
			>
				{ description }
			</Header>
		</>
	);
};

StackedBar.propTypes = {
	data: PropTypes.object,
	description: PropTypes.string,
	label: PropTypes.string
};

export default StackedBar;
